import { DEFAULT_ZOOM_LEVEL } from '@features/invoices/constants/defaultZoomLevel'
import { DOCUMENT_HTML_PREVIEW_IFRAME_MAX_WIDTH } from '@features/invoices/constants/documentHtmlPreviewDimensions'

const PREVIEW_HORIZONTAL_MARGIN = 64

export const getInvoicingSettingsPreviewZoom = (wrapperWidth: number): number => {
  const initialZoom = Math.min(
    DEFAULT_ZOOM_LEVEL,
    (wrapperWidth - PREVIEW_HORIZONTAL_MARGIN) / DOCUMENT_HTML_PREVIEW_IFRAME_MAX_WIDTH,
  )

  if (initialZoom < 0) {
    return 0
  }

  return initialZoom
}
